import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { reactive } from 'vue';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

    const getQueryString = (str:string,key:string) => {
        if(str) {
            let queryString = str.split('?')[1] || '';
            let arr = queryString.split('&') || [];
            for(let i = 0; i<arr.length; i++) {
                let keyString = decodeURIComponent(arr[i].split('=')[0]);
                let valueString = decodeURIComponent(arr[i].split('=')[1]);
                if(key === keyString) {
                    return valueString;
                }
            }
            return '';
        } else {
            return '';
        }
    }
    const data = reactive({
        queryUrl:'',
        token:''
    })
    let finalUrl = '';
    let thisHref = window.sessionStorage.getItem('thisHref');
    console.log('thisHref--------',thisHref);
    if(thisHref){
        data.queryUrl = thisHref;
    }else{
        data.queryUrl = getQueryString(location.href,'finalUrl')
    }
    data.token = getQueryString(location.href,'token')
    window.localStorage.setItem("ACCESSTOKEN",data.token)
    finalUrl = data.queryUrl

    console.log('finalUrl22----------',finalUrl);
    window.sessionStorage.removeItem('thisHref');
    location.replace(finalUrl)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})